import { Controller } from '@hotwired/stimulus'

// data-controller="coach--clipboard" — copies data-coach--clipboard-text-value
export default class extends Controller {
  static values = { text: String }

  copy() {
    navigator.clipboard.writeText(this.textValue)
    this.element.querySelector('[data-copied-label]')?.classList.remove('hidden')
  }
}
